<template>
  <Sidebar>
    <SidebarHeader>
      <Header />
    </SidebarHeader>
    <SidebarContent>
      <MenuGroups :groups="menuGroups" />
    </SidebarContent>
    <SidebarFooter>
      <SignOutButton />
    </SidebarFooter>
  </Sidebar>
</template>

<script setup lang="ts">
import SignOutButton from '@/components/shared/SignOutButton.vue';
import Header from '@/components/shared/sidebar/Header.vue';
import { useAgentSidebar } from './useAgentSidebar.ts';
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from '@/components/ui/sidebar';
import MenuGroups from '@/components/shared/sidebar/MenuGroups.vue';

const { menuGroups } = useAgentSidebar();
</script>
